// Meta Pixel (Facebook Pixel) utility
// Pixel ID: 1208943811387536

declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: any
  }
}

export function initMetaPixel() {
  if (window.fbq) return // Already initialized

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)

  window.fbq('init', '1208943811387536')
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'El Protocolo de Sueño Profundo',
      content_type: 'product',
      value: 9.36,
      currency: 'USD',
    })
  }
}
